"use strict";
const DEFAULT_TOKEN_LIST = "https://assets.swap.w3us.site/networks/flow.json";
export const DEFAULT_INACTIVE_LIST_URLS = [];
export const DEFAULT_ACTIVE_LIST_URLS = [DEFAULT_TOKEN_LIST];
export const DEFAULT_LIST_OF_LISTS = [DEFAULT_TOKEN_LIST];
